import { translate } from 'loankeeper-common/helpers'

export const translateLkMessage = (message: string) => translate(`LKMESSAGE-${message}`)

export default (key) => translate(`frm_something-${key}`)
